import * as React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { components } from 'react-select';


const CustomValueContainer = ({ children, ...props }) => {
	const selected = props.getValue();
	const totalOptions = props.selectProps?.totalOptions ?? 0;
	const [placeholder, input] = children;

	if (!selected || selected.length === 0) {
		return (
			<components.ValueContainer {...props}>
				{placeholder}
			</components.ValueContainer>
		);
	}

	let displayText = '';

	if (selected.length === 1 && totalOptions === 1) {
		displayText = selected[0].label;
	} else if (totalOptions > 0 && selected.length === totalOptions) {
		displayText = 'All';
	} else if (selected.length > 2 && selected.length < totalOptions) {
		const firstTwo = selected.slice(0, 2).map(v => v.label).join(', ');
		displayText = `${firstTwo}..+${selected.length - 2} more`;
	} else {
		displayText = selected.map(v => v.label).join(', ');
	}
	return (
		<components.ValueContainer {...props}>
			<div style={{
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				fontSize: '14px'
			}}>
				{displayText}
			</div>
		</components.ValueContainer>
	);
};
const FCSelectSiteField = ({
	value,
	onChange,
	id,
	isValueEntered,
	options,
	className,
	isDropdown, placeholder,count
}) => {

	const handleChange = (event) => {
		onChange(event);
	};
	return (
		<>
			{isDropdown ? (
				<Select
					id={id}
					name={id}
					onChange={(event) => handleChange(event)}
					placeholder={placeholder}
					value={value}
					options={options}
					styles={{
						option: (provided) => ({
							...provided,
							color: "#002366",
						}),
						control: (provided, state) => ({
							...provided,
							boxShadow: "none",
							border: "none",
							backgroundColor: "none",
							cursor: "pointer",
						}),
						singleValue: (provided) => ({
							...provided,
							color: "#002366",
						}),
					}}
					className={
						"basic-multi-select border-2 rounded-2xl text-fcinputtext " +
						(!isValueEntered ? " border-red-300 " : " border-gray-300 ") +
						className
					}
					classNamePrefix="select"
				/>) : (<Select
					isMulti
					value={value}
					onChange={handleChange}
					options={options}
					hideSelectedOptions={false}
					menuIsOpen={false}
					placeholder={placeholder}
					closeMenuOnSelect={false}
					controlShouldRenderValue={true}
					isSearchable={false}
					components={{
						DropdownIndicator: null,
						ClearIndicator: null,
						IndicatorSeparator: null,
						MultiValueRemove: () => null,
						ValueContainer: CustomValueContainer,
					}}
					totalOptions={count}
					className="border-2 border-gray-300 p-1  rounded-2xl"
					classNamePrefix="select"
					styles={{
						control: (provided) => ({
							...provided,
							flexWrap: 'nowrap',
							overflowX: 'auto',
							minHeight: '36px',
							width: '250px',
							maxWidth: "250px",
							padding: '2px',
							border: 'none',
							boxShadow: 'none',
							cursor: "pointer",
						}),
						valueContainer: (provided) => ({
							...provided,
							padding: 0,
							overflowX: 'auto',
						}),
					}}
				/>)}
		</>
	);
};

FCSelectSiteField.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	id: PropTypes.string,
	isError: PropTypes.bool,
	className: PropTypes.string,
	isValueEntered: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired,
		}),
	),
};

FCSelectSiteField.defaultProps = {
	value: "",
	isValueEntered: true,
	className: "",
};

export default FCSelectSiteField;

